import { GET } from "../../APiHelper/API";

export const getDerbiesForTeam = (team_id, onSuccess, onError) => {

    GET(`/api/v1/leagues/team/${team_id}/derbies`, onSuccess, onError)
}